import { useRef, useState } from 'react';

import { useOnClickOutside } from '../useOnClickOutside/useOnClickOutside';

/* ---------------------------------- Types --------------------------------- */

/**
 * UseDropdownI
 *
 * Object returned from the useDropdown hook
 */
export interface UseDropdownI {
    /** A reference to the button clicked to toggle the dropdown that contains the rest the whole menu object */
    containerRef: React.RefObject<HTMLDivElement>;

    /** A flag that should decide whether or not to display the dropdown menu */
    showDropdown: boolean;

    /** A callback that toggles the showDropdown flag on and off */
    toggleDropdown: () => void;
}

/* -------------------------------- Component ------------------------------- */

/**
 * useDropdown
 *
 * a
 *
 * @returns UseDropdownI
 */
export const useDropdown = (): UseDropdownI => {
    const containerRef = useRef<HTMLDivElement>(null);

    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    useOnClickOutside(containerRef, () => setShowDropdown(false));

    return {
        containerRef,
        showDropdown,
        toggleDropdown,
    };
};
